import { render, staticRenderFns } from "./make-picture.vue?vue&type=template&id=2f376e8b&lang=pug&"
import script from "./make-picture.vue?vue&type=script&lang=js&"
export * from "./make-picture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports